var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative h-0 w-full pb-full",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"absolute bottom-0 left-0 right-0 top-0"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }